import { Map, List, fromJS } from "immutable";
import { combineReducers } from "redux";
import {
  FETCH_SUBSCRIPTION_ADD_ONS_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_ACCOUNT_SETTINGS_SUCCESS,
} from "~/store/action_types";

const addOns = (state = Map(), action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
    case FETCH_SUBSCRIPTION_ADD_ONS_SUCCESS: {
      if (!action.response || !action.response.entities || !action.response.entities.addons) {
        return state;
      }

      return fromJS(action.response.entities.addons);
    }

    case FETCH_ACCOUNT_SETTINGS_SUCCESS: {
      if (!action.response || !action.response.pricing_model || !action.response.pricing_model.addons) {
        return state;
      }

      state = state.setIn([`addons`, `name`], action.response.pricing_model.addons);

      return state;
    }
    default:
      return state;
  }
};

const addOnsNames = (state = List(), action = {}) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_ADD_ONS_SUCCESS: {
      if (!action.response || !action.response.result || !action.response.result.addons) {
        return state;
      }

      return fromJS(action.response.result.addons);
    }

    default:
      return state;
  }
};

export default combineReducers({
  addOns,
  addOnsNames,
});
